import { useEffect } from 'react';
import { useCookieConsent } from '../contexts/CookieConsentContext';

/**
 * Conditionally loads analytics and marketing scripts based on user consent.
 * This component renders nothing — it only manages script injection.
 */
export const ConditionalScripts = () => {
  const { consent } = useCookieConsent();

  useEffect(() => {
    if (!consent) return;

    // Analytics scripts (e.g., Google Analytics)
    if (consent.analytics) {
      // Placeholder: Replace with your actual GA measurement ID
      const GA_ID = window.__GA_MEASUREMENT_ID__;
      if (GA_ID && !document.getElementById('ga-script')) {
        const script = document.createElement('script');
        script.id = 'ga-script';
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
        document.head.appendChild(script);

        const inlineScript = document.createElement('script');
        inlineScript.id = 'ga-inline';
        inlineScript.textContent = `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${GA_ID}', { anonymize_ip: true });
        `;
        document.head.appendChild(inlineScript);
      }
    }

    // Marketing scripts (e.g., Facebook Pixel, ad pixels)
    if (consent.marketing) {
      // Placeholder: Replace with your actual pixel IDs when ready
      // Example: Facebook Pixel would be loaded here
    }
  }, [consent]);

  return null;
};
